import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const ViewAllOverlay = ({ to }) => {
  return (
    <div className="absolute inset-x-0 bottom-0 z-20 flex flex-col items-center justify-end pointer-events-none">
      <div
        className="w-full h-32 bg-gradient-to-t from-[#0D0D0D] via-[#0D0D0D]/95 to-transparent"
        aria-hidden="true"
      />
      <div className="absolute bottom-6 left-0 right-0 flex justify-center">
        <Link
          to={to}
          className="pointer-events-auto group flex items-center gap-2 px-8 py-3 bg-[#c9923f] hover:bg-[#b8822e] text-white font-semibold text-sm uppercase tracking-[0.2em] rounded-md shadow-[0_8px_32px_rgba(0,0,0,0.5)] transition-all duration-300 hover:scale-105"
        >
          View All
          <ChevronRight
            size={18}
            className="transition-transform duration-300 group-hover:translate-x-1"
          />
        </Link>
      </div>
    </div>
  );
};

export default ViewAllOverlay;
